import React, { useState } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Alert from '@material-ui/lab/Alert';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { createTheme, makeStyles } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import Container from '@material-ui/core/Container';
import PersonIcon from '@material-ui/icons/Person';
import { useHistory } from 'react-router-dom';
const axios = require('axios');

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const theme = createTheme({
  palette: {
    primary: { main: '#26477c' },
  },
});

const RequestPasswordReset = () => {
  let [resetEmail, setResetEmail] = useState('');
  let [errorMsg, setErrorMsg] = useState('');
  let [instructionMsg, setInstructionMsg] = useState('');

  let history = useHistory();

  const classes = useStyles();

  let emailErrors = false;
  let helperText = null;

  if (!resetEmail) {
    emailErrors = true;
    helperText = 'Email Address field is required';
  }

  if (resetEmail) {
    if (errorMsg) {
      emailErrors = true;
      helperText = errorMsg;
    }

    if (!resetEmail.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/)) {
      emailErrors = true;
      helperText = 'Incorrect email format';
    }
  }

  let dialog = <></>;
  if (instructionMsg) {
    dialog = <Alert severity='success'>{instructionMsg}</Alert>;
  }

  return (
    <ThemeProvider theme={theme}>
      <Container component='main' maxWidth='xs'>
        <CssBaseline />
        <div className={classes.paper}>
          <Avatar className={classes.avatar}>
            <PersonIcon />
          </Avatar>
          <Typography component='h1' variant='h5'>
            Reset Password
          </Typography>
          {dialog}
          <form className={classes.form} noValidate>
            <TextField
              error={emailErrors}
              helperText={helperText}
              onChange={(event) => {
                setResetEmail(event.target.value);
                setErrorMsg(false);
              }}
              variant='outlined'
              margin='normal'
              required
              fullWidth
              id='email'
              label='Email Address'
              name='email'
              autoComplete='email'
              autoFocus
            />
            <div>
              <Button
                onClick={() => {
                  let body = {
                    action: 'sendResetLink',
                    accountEmail: resetEmail,
                  };
                  axios
                    .post(`${process.env.REACT_APP_API}/forgotPassword`, body)
                    .then((result) => {
                      let { token, errMsg = false } = result.data;
                      if (!errMsg) {
                        setInstructionMsg(
                          'Reset password instructions has been sent to your email'
                        );
                      } else {
                        setErrorMsg(errMsg);
                      }
                    });
                }}
                style={{ width: '49%' }}
                variant='contained'
                color='primary'
                className={classes.submit}>
                Submit
              </Button>
              <span>&nbsp;</span>
              <Button
                onClick={() => {
                  history.push('/login');
                }}
                style={{ width: '49%' }}
                variant='contained'
                color='primary'
                className={classes.submit}>
                Back
              </Button>
            </div>
            <Grid container>
              <Grid item></Grid>
            </Grid>
          </form>
        </div>
      </Container>
    </ThemeProvider>
  );
};

export default RequestPasswordReset;
